import { GetAssociatedDevicesInUnitQueryArg } from '../types/query-arg';
import { GetAssociatedDevicesInUnitQueryParams } from '../types/query-params';

export const getAssociatedDevicesInUnitQueryParams = (
  queryArg: GetAssociatedDevicesInUnitQueryArg,
): GetAssociatedDevicesInUnitQueryParams => ({
  unitId: queryArg.unit.id,
});
